import styled from 'styled-components'

export const Bubble = styled.span`
  min-width: 1.5em;
  min-height: 1.5em;
  text-align: center;
  background: ${p => p.theme.palette.negative};

  border-radius: 50%;
  color: ${p => p.theme.palette.always_white};
  font-weight: bold;
  position: absolute;
  top: -8px;
  right: -8px;
  font-size: 65%;

  &.multipleDigits {
    padding-left: 2px;
    padding-right: 2px;
  }

  &.info {
    background: ${p => p.theme.palette.themePrimary};
    color: ${p => p.theme.palette.white};
  }
`
